import React from 'react';
import { observer } from 'mobx-react';

const Welcome = observer((props) => {

  return (
    <>
      <div class="row">   
        <div class="col-md p-4">
          <h1>Welcome to the Support Center</h1>
          <p>Before we get started please acknowledge that you understand this is a pop-up window that may lose focus and go behind other windows.</p>
          <p>If you do lose focus of this window and it "disappears" you can get it back using one of the following methods:</p>
          <ul>
            <li>Clicking the support button again <strong>(preferred)</strong></li>
            <li>Finding the window among your other open Chrome windows.</li>            
          </ul>
        </div>

        <p className='text-center'>
          <button type="button" class="btn btn-primary" onClick={props.acknowledge}>Got it, lets go!</button>
        </p>
      </div>
    </>
  );
});

export default Welcome;